import { useEffect, memo } from 'react';

import { isAccessEnded } from '../../helpers/utils/functions';
import MainLayout from '../../shared/common/components/layouts/MainLayout';
import Loader from '../../shared/common/components/loader/Loader';
import CreateMetricsModal from '../../shared/common/components/reports/CreateMetricsModal';
import { listKeysGroupingsPayment as listKeysGroupings, listKeysMetricsPayment as listKeysMetrics } from '../../shared/common/components/reports/modal-settings/index';
import FirstRegIcon from '../../shared/common/components/reports/params/attribution/icons/FirstRegIcon';
import LastRegIcon from '../../shared/common/components/reports/params/attribution/icons/LastRegIcon';
import TypeIcon from '../../shared/common/components/reports/params/attribution/icons/TypeIcon';
import Params from '../../shared/common/components/reports/params/Params';
import ReportChart from '../../shared/common/components/reports/chart/ReportChart';
import ReportTable from '../../shared/common/components/reports/report-table';
import UniversalReportTitle from '../../shared/common/components/reports/un-title/UniversalReportTitle';
import { chartDetails } from '../../shared/common/constants/details';
import { createAttrItems } from '../../shared/common/constants/report-constants';
import { useTypedSelector } from '../../shared/common/hooks/useTypedSelector';
import { useReportPageInit } from '../../shared/common/hooks/useReportPageInit';

interface MetricListItem {
    dataKey: string;
    name?: string;
    label?: string;
    [key: string]: unknown;
}

interface GroupingListItem {
    dataKey: string;
    name?: string;
    label?: string;
    [key: string]: unknown;
}

// Дефолтные метрики для Payment отчёта (dataKey уже содержит суффикс _3)
export const defaultMetricsPayment = [
    'payments_count_3',
    'buyers_count_3',
    'payments_sum_3',
    'payments_sum_avg_3',
    'payments_commission_sum_3',
    'payments_sum_with_commission_3',
].map((dataKey) => listKeysMetrics.find((m: MetricListItem) => m.dataKey === dataKey))
 .filter((item): item is MetricListItem => item !== undefined);

// Дефолтные группировки для Payment отчёта (dataKey уже содержит суффикс _3)
export const defaultGroupingsPayment = [
    'reg_utm_source_3',
    'reg_utm_medium_3',
    'reg_utm_campaign_3',
].map((dataKey) => listKeysGroupings.find((g: GroupingListItem) => g.dataKey === dataKey))
 .filter((item): item is GroupingListItem => item !== undefined);

// Для числовых отчётов
export const defaultMetricsOrderPayment = [
    'payments_count_3',
].map((dataKey) => listKeysMetrics.find((m: MetricListItem) => m.dataKey === dataKey))
 .filter((item) => item !== undefined);

export const defaultGroupingPayment = [
    'payment_date_y_3',
].map((dataKey) => listKeysGroupings.find((g: GroupingListItem) => g.dataKey === dataKey))
 .filter((item) => item !== undefined);

const PaymentReports = () => {
    // Используем универсальный хук для инициализации страницы отчёта
    const { isChartLoading } = useReportPageInit({
        defaultMetrics: defaultMetricsPayment,
        defaultGroupings: defaultGroupingsPayment,
    });
    
    useEffect(() => {
        document.body.style.overflow = 'scroll';
        document.body.style.overflowX = 'auto';
        
        return () => {
            document.body.style.overflow = '';
            document.body.style.overflowX = '';
        };
    }, []);
    
    const attrItems = createAttrItems(<TypeIcon />, <FirstRegIcon />, <LastRegIcon />);
    const { isCreateMetricsVisible } = useTypedSelector((state) => state.reports);
    const accessEnded = isAccessEnded();
    
    return (
        <>
            <MainLayout pageTitle="Отчёт по платежам">
                <div className="page-wrapper">
                    {accessEnded ? (
                        <iframe
                            style={{ border: 'none', width: '990px', float: 'left', minHeight: '100vh', marginTop: '2vh' }}
                            src={`https://doc.scananalytics.ru/oshibki-i-preduprezhdeniya/dostup-k-otchetam-po-platezham-zakryt/?timestamp=${new Date().getTime()}`}
                            width="100%"
                            height="100%"
                        />
                    ) : (
                        <div className="page-content">
                            <UniversalReportTitle />
                            <Params
                                attributionItems={attrItems}
                                detailsItems={chartDetails}
                                filtersFilter={[
                                    'Пользователи',
                                    'Регистрации',
                                    'Заказы',
                                    'Платежи',
                                ]}
                            />
                            <Loader loading={isChartLoading}>
                                <ReportChart reportType="payment" />
                            </Loader>
                            <ReportTable reportType="payment" />
                        </div>
                    )}
                </div>
            </MainLayout>

            {isCreateMetricsVisible && (<CreateMetricsModal title="Создание метрики в отчете по платежам" />)}
        </>
    );
};

export default memo(PaymentReports);
